<template>
<div>
    <sidebar-item :link="{ name: 'USUÁRIOS', icon: 'fas fa-users-cog text-info' }">
        <sidebar-item v-if="permissoes.usuarioRead" :link="{ name: 'USUÁRIOS', path: '/usuarios', icon: 'fas fa-users' }" />
        <sidebar-item v-if="permissoes.niveis_acessoRead" :link="{ name: 'NÍVEIS ACESSO', path: '/niveis-acesso', icon: 'fas fa-user-shield' }" />
    </sidebar-item>
</div>
</template>

<script>
import {
    mapState
} from 'vuex'

export default {
    computed: mapState(['usuario']),
    name: 'SidebarUsuario',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    },

}
</script>
